import styled from "styled-components";
import { Table, Empty } from "antd";
import { StyledTableProps } from "./types";

// export const StyledTable = styled(AntTable)`
//   .ant-table-thead > tr > th {
//     background: rgb(242, 242, 245) !important;
//     font-weight: 600;
//     border-right: none !important;
//     border-top: none !important;
//     padding: 10px 12px !important;
    
//     &:first-child {
//       border-left: none !important;
//       border-top-left-radius: 8px !important;
//       border-bottom-left-radius: 8px !important;
//     }
    
//     &:last-child {
//       border-right: none !important;
//       border-top-right-radius: 8px !important;
//       border-bottom-right-radius: 8px !important;
//     }
//   }

//   .ant-table-thead > tr > th:not(:last-child) {
//     border-right: none !important;
//   }

//   .ant-table-tbody > tr > td {
//     padding: 10px 12px !important;
//     border-bottom: 1px solid #DCDCDC !important;
//   }

//   .ant-table-tbody > tr:hover > td {
//     background: #f5f5f5;
//   }

//   .ant-table-thead > tr > th {
//     border-bottom: 0 !important;
//     border-top: 0 !important;
//   }

//   /* Custom scrollbar styling - remove arrows */
//   .ant-table-body {
//     &::-webkit-scrollbar {
//       width: 8px;
//       height: 8px;
//     }

//     &::-webkit-scrollbar-track {
//       background: #f1f1f1;
//       border-radius: 4px;
//     }

//     &::-webkit-scrollbar-thumb {
//       background: #c1c1c1;
//       border-radius: 4px;

//       &:hover {
//         background: #a8a8a8;
//       }
//     }

//     /* Remove scrollbar arrows */
//     &::-webkit-scrollbar-button {
//       display: none;
//       width: 0;
//       height: 0;
//     }
//   }

//   /* For Firefox */
//   .ant-table-body {
//     scrollbar-width: thin;
//     scrollbar-color: #c1c1c1 #f1f1f1;
//   }
// `;

export const StyledTable = styled(Table)<StyledTableProps>`
  ${p => p?.border && (p?.borderBottomLeftRight ?
    `border-top: none !important; border-bottom: ${p.border} !important; border-left: ${p.border} !important; border-right: ${p.border} !important;` :
    `border: ${p.border} !important;`)};
  ${p => p?.borderRadius && `border-radius: ${p?.borderRadius} !important;`};
  ${p => p?.borderBottomLeftRadius && `border-bottom-left-radius: ${p?.borderBottomLeftRadius} !important;`};
  ${p => p?.borderBottomRightRadius && `border-bottom-right-radius: ${p?.borderBottomRightRadius} !important;`};
  table {
    margin-bottom: 0px;
    table-layout: auto;
  }
 .ant-table-body {
  background-color: ${p => p?.theme === 'dark' ? '#1a202c' : 'transparent'} !important;
  overflow-y: ${p => p?.disableScroll ? 'hidden' : 'auto'} !important;
  overflow-x: ${p => p?.disableScroll ? 'hidden' : 'auto'} !important;
  ${p => p?.minHeight && `min-height: ${p?.minHeight}px !important;`}
  &::-webkit-scrollbar {
      width: 4px;
      border-radius: 20px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: lightgray;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: #888;
    }

    &::-webkit-scrollbar-thumb:hover {
      border-radius: 10px;
      background: #7a7a7a; 
    }
}
 
  .column-title {
    line-height: 14px;
  }
  .ant-spin-nested-loading {
    .ant-spin-container {
    .ant-table {
      ${p => p?.borderBottomLeftRadius && `border-bottom-left-radius: ${p?.borderBottomLeftRadius} !important;`};
      ${p => p?.borderBottomRightRadius && `border-bottom-right-radius: ${p?.borderBottomRightRadius} !important;`};
      .ant-table-container {
          table {
            .ant-table-tbody {
              tr {
                td {
                  padding: ${p => p?.tdPadding || '5px 10px'} !important;
                  p {
                    margin-bottom: 0px !important;
                  }
                }
                ${p => p?.firstColumnNoLeftPadding && `
                  td:first-child {
                    padding-left: 0 !important;
                  }
                `}
              }
            }
          }
        }
      }
    }
  }
  .ant-table-cell:last-child {
    ${p => p?.removeVerticalBorders ? 'border-right: none !important;' : 'border-right: 1px solid #E8E8E8;'}
  }
  .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before{
    display: none;
  }
  tbody tr:hover {
    background-color: ${p => p?.theme === 'dark' ? '#4a5568' : '#F4F5F8'} !important;
  }
  .ant-table-tbody > tr.urgent-dispute-row > td {
    background: #fff1f0 !important;
  }

  .ant-table-tbody > tr.urgent-dispute-row:hover > td {
    background: #ffe7e6 !important;
  }

  .ant-table-tbody tr {
    background-color: ${p => p?.theme === 'dark' ? '#1a202c' : '#fff'} !important;
  }
  
  .ant-table-tbody tr td {
    ${p => p?.removeVerticalBorders ? 'border-right: none !important;' : `border-right: 1px solid ${p?.theme === 'dark' ? '#718096' : '#E8E8E8'} !important;`}
    color: ${p => p?.theme === 'dark' ? '#ffffff' : 'inherit'} !important;
    background-color: ${p => p?.theme === 'dark' ? '#1a202c' : '#fff'} !important;

    p {
      color: ${p => p?.theme === 'dark' ? '#ffffff' : 'inherit'} !important;
      margin: 0;
    }

    span {
      color: ${p => p?.theme === 'dark' ? '#ffffff' : 'inherit'} !important;
    }

    /* &:hover {
      .penIcon {
        opacity: 1;
      }
    } */
    .penIcon {
      cursor: pointer;
      margin-top: 5px;
      opacity: 1;
      transition: opacity 0.2s ease-in-out;
      padding: 10px;
      border-radius: 50%;
      &:hover {
        background-color: #d3d4d8;
        border-radius: 50%;
      }
    }

    /* Fixed column body cells */
    &.ant-table-cell-fix-left {
      z-index: 999 !important;
      position: sticky !important;
      background-color: ${p => p?.theme === 'dark' ? '#1a202c' : '#fff'} !important;
    }
  }

  .ant-table-tbody tr:hover td.ant-table-cell-fix-left {
    z-index: 999 !important;
    background-color: ${p => p?.theme === 'dark' ? '#4a5568' : '#F4F5F8'} !important;
  }
  
  /* Empty state text styling */
  .ant-empty {
    .ant-empty-description {
      color: ${p => p?.theme === 'dark' ? '#ffffff' : '#8c8c8c'} !important;
    }
    
    .ant-empty-image {
      svg {
        fill: ${p => p?.theme === 'dark' ? '#4A5568' : '#d9d9d9'} !important;
      }
    }
  }
  
  /* Table placeholder styling */
  .ant-table-placeholder {
    .ant-empty {
      .ant-empty-description {
        color: ${p => p?.theme === 'dark' ? '#ffffff' : '#8c8c8c'} !important;
      }
    }
  }

  .ant-table-tbody tr .businessNameEditIcon {
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    color: #666666;
    border-radius: 50%;
    font-size: 13px;
    :hover {
      color: #2d6cca;
    }
  }

  .ant-table-tbody tr td:first-child:hover .businessNameEditIcon {
    opacity: 1;
  }

  .ant-table-tbody tr .businessNameEditIcon.active {
    opacity: 1;
  }

  &.main-google-ads-table .ant-table-tbody tr.active-dropdown-row {
    position: relative;
    z-index: 50;
  }
  
  &.main-google-ads-table .ant-table-tbody tr.active-dropdown-row td {
    z-index: 50;
  }
  
  &.main-google-ads-table .ant-table-tbody tr.active-dropdown-row .ant-table-cell-fix-left {
    z-index: 51;
  }

  .ant-table-content {
    overflow: ${p => p?.disableScroll ? 'hidden' : 'auto'} !important;
    margin-bottom: ${p => p?.tableContentMarginBottom || '20px'};
    border-radius: 9px;
    &::-webkit-scrollbar {
      width: 4px;
      border-radius: 20px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: lightgray;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: #888;
    }

    &::-webkit-scrollbar-thumb:hover {
      border-radius: 10px;
      background: #7a7a7a; 
    }
    .ant-table-cell {
      ${p => p?.removeVerticalBorders ? 'border-left: none !important;' : `border-left: 1px solid ${p?.theme === 'dark' ? '#718096' : '#E8E8E8'};`}
      color: ${p => p?.theme === 'dark' ? '#fff' : 'inherit'} !important;
      p {
        margin: 0;
        color: ${p => p?.theme === 'dark' ? '#fff' : 'inherit'} !important;
      }
    }
  }
  ${p => {
    if (p?.headerPadding) {
      const paddingValues = p.headerPadding.split(' ');
      const horizontalPadding = paddingValues.length > 1 ? paddingValues[1] : paddingValues[0];
      return `
        .ant-table-header {
          margin-left: ${horizontalPadding} !important;
          margin-right: ${horizontalPadding} !important;
        }
        .ant-table-body {
          margin-left: ${horizontalPadding} !important;
          margin-right: ${horizontalPadding} !important;
        }
      `;
    }
    return '';
  }}
  ${p => {
    if (p?.containerPadding) {
      const paddingValues = p.containerPadding.split(' ');
      const horizontalPadding = paddingValues.length > 1 ? paddingValues[1] : paddingValues[0];
      return `
        .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container {
          padding-left: ${horizontalPadding} !important;
          padding-right: ${horizontalPadding} !important;
        }
      `;
    }
    return '';
  }}
  .ant-table-thead {
    font-size: 12px;
    font-weight: 600;
    tr {
      th {
        ${p => p?.removeVerticalBorders ? 'border-right: none !important;' : `border-right: 1px solid ${p?.theme === 'dark' ? '#718096' : '#E8E8E8'};`}
        font-weight: 600;
        color: ${p => p?.theme === 'dark' ? '#fff' : 'inherit'} !important;

        /* Sort indicator styling for dark mode */
        .ant-table-column-sorter {
          color: ${p => p?.theme === 'dark' ? '#ffffff' : '#bfbfbf'} !important;

          .ant-table-column-sorter-inner {
            .ant-table-column-sorter-up,
            .ant-table-column-sorter-down {
              color: ${p => p?.theme === 'dark' ? '#ffffff' : '#bfbfbf'} !important;
              font-size: 12px !important;

              &.on {
                color: ${p => p?.theme === 'dark' ? '#1890ff' : '#1890ff'} !important;
              }
            }
          }
        }

        /* Active sort state */
        &.ant-table-column-sort {
          .ant-table-column-sorter {
            .ant-table-column-sorter-inner {
              .ant-table-column-sorter-up.on,
              .ant-table-column-sorter-down.on {
                color: ${p => p?.theme === 'dark' ? '#1890ff' : '#1890ff'} !important;
              }
            }
          }
        }
      }
      ${p => p?.firstChildBorderRadius && `
        th:first-child {
          border-top-left-radius: ${p.firstChildBorderRadius} !important;
          border-bottom-left-radius: ${p.firstChildBorderRadius} !important;
        }
      `}
      ${p => p?.secondLastChildBorderRadius && `
        th:nth-last-child(2) {
          border-top-right-radius: ${p.secondLastChildBorderRadius} !important;
          border-bottom-right-radius: ${p.secondLastChildBorderRadius} !important;
        }
      `}
      ${p => p?.actualLastChildBorderRadius && `
        th:last-child {
          border-top-right-radius: ${p.actualLastChildBorderRadius} !important;
          border-bottom-right-radius: ${p.actualLastChildBorderRadius} !important;
        }
      `}
    }
    ${p => p?.hideLastHeaderCell && `
      tr:first-child th:last-child {
        display: none !important;
      }
    `}

    .ant-table-cell-fix-left {
      background: ${p => p?.headerBackgroundColor || (p?.theme === 'dark' ? '#1a202c' : '#f2f2f5')} !important;
      color: ${p => p?.theme === 'dark' ? '#fff' : 'inherit'} !important;
      left: 0px !important;
      padding: 0 10px !important;
      z-index: 1000 !important;
      position: sticky !important;
      // border-top-left-radius: 9px !important;
    }
    .ant-table-cell {
      background: ${p => p?.headerBackgroundColor || (p?.theme === 'dark' ? '#1a202c' : '#f2f2f5')} !important;
      color: ${p => p?.theme === 'dark' ? '#fff' : 'inherit'} !important;
      left: 0px !important;
      /* margin: 0 16px !important; */
      margin-right: 30px !important;
      padding: ${p => p?.thPadding || '5px 10px'} !important;
    }
    .ant-table-cell-fix-right {
      border-top-right-radius: 9px !important;
    }
  }

  /* Fixed columns z-index for scrolling */
  .ant-table-cell-fix-left {
    z-index: 999 !important;
    position: sticky !important;
  }

  .ant-table-cell-fix-left-last::after {
    display: none !important;
  }

  /* Ensure fixed columns stay on top during scroll */
  .ant-table-thead .ant-table-cell-fix-left {
    z-index: 1000 !important;
  }

  .ant-table-tbody .ant-table-cell-fix-left {
    z-index: 999 !important;
  }
  /* .ant-table-measure-row {
    display: none !important;
  } */

  ${p => !p?.keepFirstRowPadding && `
    .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container table .ant-table-tbody tr:first-of-type td {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  `}
`;


export const EmptyContainer = styled.div`
  padding: 60px 20px;
  text-align: center;
`;

export { Empty };

